import { useMatch } from 'react-router-dom';

export const useJobProgressSegment = (): string | undefined => {
  const match = useMatch('/:entityType/:entityId/:segment');

  return match?.params?.segment;
};
